/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    FileTransferDto,
    PageUserHeaderDto,
    RoleInfoDto,
    UserHeaderCreationRequestDto,
    UserHeaderDto,
    UserHeaderUpdateRequestDto,
    UserRole
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class UserControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        activateUser(
                    userId: number
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/${userId}/activate`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        addUserRole(
                    userId: number
                , 
                queryParams: {
                    orgUnitId?: number,
                    role: string,
                    startDate?: Date,
                    endDate?: Date
                }
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/${userId}/roles`;

            return this._httpClient.post<number>(url, requestBody, requestOptions);
    }


        approveOwnerRole(
                    userId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/${userId}/owner/approve`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        approveUserRole(
                    userId: number,
                    roleId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/${userId}/roles/${roleId}/approve`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        assignAdminRole(
                    userId: number
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/${userId}/admin`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        changePassword(
                
                queryParams: {
                    oldPassword: string,
                    newPassword: string
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/changePassword`;

            return this._httpClient.put<boolean>(url, requestBody, requestOptions);
    }


        createUser(
                
                queryParams: {
                    password: string
                }
                    
                    , 
                    requestBody: UserHeaderCreationRequestDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/users`;

            return this._httpClient.post<number>(url, requestBody, requestOptions);
    }


        deactivateUser(
                    userId: number
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/${userId}/deactivate`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        deleteUserRole(
                    userId: number,
                    roleId: number
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/${userId}/roles/${roleId}`;

            return this._httpClient.delete<boolean>(url, requestOptions);
    }


        getAllAllowedUserRoles(
                
                queryParams: {
                    userAccountType?: string
                }
    ): Observable<Array<string>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/roles`;

            return this._httpClient.get<Array<string>>(url, requestOptions);
    }


        getAllRoleInfos(
    ): Observable<Array<RoleInfoDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/roles/infos`;

            return this._httpClient.get<Array<RoleInfoDto>>(url, requestOptions);
    }


        getAvatar(
                    userId: string
    ): Observable<Array<string>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/${userId}/avatar`;

            return this._httpClient.get<Array<string>>(url, requestOptions);
    }


        getOwnerRequests(
                
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<Array<UserHeaderDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/owner/requests`;

            return this._httpClient.get<Array<UserHeaderDto>>(url, requestOptions);
    }


        getProducerRolesSetPassword(
    ): Observable<Array<number>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/roles/setpassword`;

            return this._httpClient.get<Array<number>>(url, requestOptions);
    }


        getProfile(
    ): Observable<UserHeaderDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/profile`;

            return this._httpClient.get<UserHeaderDto>(url, requestOptions);
    }


        getProfileById(
                    userId: number
    ): Observable<UserHeaderDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/${userId}/profile`;

            return this._httpClient.get<UserHeaderDto>(url, requestOptions);
    }


        getUserRoles(
                    userId: number
                , 
                queryParams: {
                    actualOnly?: boolean
                }
    ): Observable<Array<UserRole>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/${userId}/roles`;

            return this._httpClient.get<Array<UserRole>>(url, requestOptions);
    }


        getUsersList(
                
                queryParams: {
                    orgUnitId?: number,
                    userAccountType?: string,
                    showInactive?: boolean
                }
    ): Observable<Array<UserHeaderDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/list`;

            return this._httpClient.get<Array<UserHeaderDto>>(url, requestOptions);
    }


        isEmailUsed(
                
                queryParams: {
                    email: string
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/emailUsed`;

            return this._httpClient.get<boolean>(url, requestOptions);
    }


        isLoginUsed(
                
                queryParams: {
                    login: string
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/loginUsed`;

            return this._httpClient.get<boolean>(url, requestOptions);
    }


        rejectOwnerRole(
                    userId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/${userId}/owner/reject`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        rejectRole(
                    userId: number,
                    roleId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/${userId}/roles/${roleId}/reject`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        removeAdminRole(
                    userId: number
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/${userId}/admin`;

            return this._httpClient.delete<boolean>(url, requestOptions);
    }


        requestOwnerStatus(
                    userId: number
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/${userId}/owner`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        searchPage1(
                
                queryParams: {
                    orgUnitId?: number,
                    userAccountType?: string,
                    showInactive?: boolean,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageUserHeaderDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/users/page`;

            return this._httpClient.get<PageUserHeaderDto>(url, requestOptions);
    }


        setNewPasswordProducerRole(
                    roleId: number
                    , 
                    
                    requestBody: string
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/users/roles/${roleId}/setpassword`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        updateUser(
                    
                    
                    requestBody: UserHeaderUpdateRequestDto
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/users`;

            return this._httpClient.put<boolean>(url, requestBody, requestOptions);
    }


        updateUserAvatar(
                
                queryParams: {
                    fileName?: string,
                    mediaType?: string
                }
                    
                    , 
                    requestBody: FileTransferDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/users/avatar`;

            return this._httpClient.put<number>(url, requestBody, requestOptions);
    }


}

